import type { TSearchResultsItem } from '../types'

const MAX_PREVIOUS_SEARCHES = 3

export const addPreviousSearch = (
  previousSearches: TSearchResultsItem[],
  item: TSearchResultsItem,
): TSearchResultsItem[] => {
  // the prefix keeps the value unique when the same item also shows in the results
  const value = item.type === 'PREVIOUS_SEARCH' ? item.value : `PREVIOUS_SEARCH-${item.value}`
  const previousSearch: TSearchResultsItem = { ...item, type: 'PREVIOUS_SEARCH', value }
  const otherPreviousSearches = previousSearches.filter((s) => s.value !== value)

  return [previousSearch, ...otherPreviousSearches].slice(0, MAX_PREVIOUS_SEARCHES)
}
